import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { ArrowLeft } from "lucide-react";
import bkashLogo from "../assets/icons/bkash.png";
import nagadLogo from "../assets/icons/nagad.png";
import rocketLogo from "../assets/icons/rocket.png";

export default function PaymentPage() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const amount = Number(queryParams.get("amount")) || 0;
  const method = (queryParams.get("method") || "Bkash").trim();
  const [trxId, setTrxId] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
// ⬅️ Add after function PaymentPage() { 
const [settings, setSettings] = useState({
  bkash: "",
  nagad: "",
  rocket: "",
  instructions: ""
});

// Load numbers + instructions from Admin Settings
useEffect(() => {
  const load = async () => {
    try {
      const res = await axios.get("https://api.speedfollowinfo.com/api/settings");
      setSettings({
  bkash: res.data.bkash,
  nagad: res.data.nagad,
  rocket: res.data.rocket,
  instructions:
    method === "Bkash"
      ? res.data.bkashInstruction
      : method === "Nagad"
      ? res.data.nagadInstruction
      : res.data.rocketInstruction
});
    } catch (err) {
      console.error("Failed to load settings", err);
    }
  };
  load();
}, []);
  // ================================
  // ✅ HARD ENFORCE Minimum Amount = 50 TK
  // ================================
  useEffect(() => {
  if (amount < 50) {
    const modal = document.createElement("div");
    modal.innerHTML = `
      <div style="
        position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.85);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 999999;
      ">
        <div style="
          background: #220000;
          width: 90%;
          max-width: 420px;
          padding: 30px;
          border-radius: 15px;
          border: 2px solid red;
          color: white;
          text-align: center;
          box-shadow: 0 0 35px rgba(255,0,0,0.6);
          animation: shake 0.25s ease-in-out;
        ">
          <div style="font-size:70px; margin-bottom:10px;">🚫</div>

          <h2 style="font-size:26px; font-weight:bold; color:#ff4444;">
            ALERT: Minimum Add Amount is ৳50
          </h2>

          <p style="
            font-size:17px;
            margin: 15px 0;
            line-height:1.5;
            color:#ffbbbb;
          ">
            বেশি পন্ডিতি করতে আসবা না!  
            আবার URL পরিবর্তন করলে <b style="color:#ff3333;">Account Suspend</b> করে দেওয়া হবে।
          </p>

          <button style="
            margin-top:15px;
            background:#ff3333;
            border:none;
            padding:10px 25px;
            font-size:18px;
            font-weight:bold;
            border-radius:8px;
            cursor:pointer;
            color:white;
          ">OK</button>
        </div>
      </div>

      <style>
        @keyframes shake {
          0% { transform: translateX(0); }
          25% { transform: translateX(-8px); }
          50% { transform: translateX(8px); }
          75% { transform: translateX(-8px); }
          100% { transform: translateX(0); }
        }
      </style>
    `;

    modal.querySelector("button").onclick = () => {
      modal.remove();
      window.location.href = "/addfunds";
    };

    document.body.appendChild(modal);
  }
}, [amount]);

  // ================================
  // Copy Function
  // ================================
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    const msg = document.createElement("div");
    msg.textContent = "✅ Copied!";
    msg.style.position = "fixed";
    msg.style.top = "20px";
    msg.style.right = "20px";
    msg.style.background = "#4ade80";
    msg.style.color = "#0b0f1a";
    msg.style.fontWeight = "600";
    msg.style.padding = "10px 18px";
    msg.style.borderRadius = "8px";
    msg.style.boxShadow = "0 0 15px rgba(0,0,0,0.5)";
    msg.style.zIndex = "9999";
    document.body.appendChild(msg);
    setTimeout(() => msg.remove(), 1500);
  };

  // ================================
  // Payment Method Data
  // ================================
  const paymentMethods = [
  {
    name: "Bkash",
    color: "#E2136E",
    logo: bkashLogo,     // ✅ LOCAL IMAGE
    number: settings.bkash,
    steps: (settings.instructions || "").split("\n"),
  },
  {
    name: "Nagad",
    color: "#F7941D",
    logo: nagadLogo,     // ✅ LOCAL IMAGE
    number: settings.nagad,
    steps: (settings.instructions || "").split("\n"),
  },
  {
    name: "Rocket",
    color: "#8B3EFF",
    logo: rocketLogo,    // ✅ LOCAL IMAGE
    number: settings.rocket,
    steps: (settings.instructions || "").split("\n"),
  },
];
// ================================
// Select active method
// ================================
const selected =
  paymentMethods.find(
    (m) => m.name.toLowerCase() === method.toLowerCase()
  ) || paymentMethods[0];
// ================================
// GLOBAL MODAL FUNCTION
// ================================
const showModal = (title, message, type = "info", onClose = null) => {
  const modal = document.createElement("div");
  modal.style.position = "fixed";
  modal.style.top = 0;
  modal.style.left = 0;
  modal.style.width = "100%";
  modal.style.height = "100%";
  modal.style.background = "rgba(0,0,0,0.8)";
  modal.style.display = "flex";
  modal.style.alignItems = "center";
  modal.style.justifyContent = "center";
  modal.style.zIndex = 9999;

  const box = document.createElement("div");
  box.style.background = "#161c34";
  box.style.padding = "25px 30px";
  box.style.borderRadius = "16px";
  box.style.width = "90%";
  box.style.maxWidth = "420px";
  box.style.textAlign = "center";
  box.style.color = "white";
  box.style.border = "1px solid #2f3b6c";
  box.style.boxShadow = "0 0 25px rgba(0,0,0,0.5)";

  let emoji =
    type === "success"
      ? "✅"
      : type === "error"
      ? "❌"
      : type === "warning"
      ? "⚠️"
      : "ℹ️";

  box.innerHTML = `
      <div style="font-size:48px; margin-bottom:10px;">${emoji}</div>
      <h2 style="font-size:22px; font-weight:700; margin-bottom:10px;">${title}</h2>
      <p style="font-size:16px; line-height:1.6; white-space:pre-line;">${message}</p>
      <button id="closeModalBtn"
        style="
          margin-top:20px;
          background:#f2a900;
          padding:10px 20px;
          border-radius:8px;
          font-weight:bold;
          color:#000;
          cursor:pointer;
          width:100%;
        ">
        OK
      </button>
  `;

  modal.appendChild(box);
  document.body.appendChild(modal);

  document.getElementById("closeModalBtn").onclick = () => {
    modal.remove();
    if (onClose) onClose();
  };
};

// 🔒 Transaction ID Validator (FINAL RULE)
const isValidTrxId = (trx, method) => {
  const clean = trx.trim();

  // 1️⃣ Only CAPITAL letters OR only numbers OR mix (CAPITAL + number)
  const validPattern = /^[A-Z0-9]+$/;

  if (!validPattern.test(clean)) return false;

  // 2️⃣ Length check (8–15)
  if (clean.length < 8 || clean.length > 15) return false;

  // 3️⃣ Reject if ANY lowercase letter exists
  if (/[a-z]/.test(clean)) return false;

  return true;
};
// ================================
// 🔁 Duplicate Transaction Checker
// ================================
const isDuplicateTrx = (trx, amount) => {
  const pending = JSON.parse(localStorage.getItem("pendingFunds")) || [];

  return pending.some(
    (p) =>
      p.trxId.toLowerCase() === trx.toLowerCase() &&
      Number(p.amount) === Number(amount)
  );
};
// ================================
// 🏁 Approved Transaction Checker
// ================================
const isApprovedTrx = (trx) => {
  const approved = JSON.parse(localStorage.getItem("approvedTrx")) || [];
  return approved.includes(trx.toLowerCase());
};
  // ==========================================
// 🔥 NEW VERIFY Handler with Custom MODAL UI
// ==========================================
const handleConfirm = async () => {
if (isSubmitting) return; // prevent double click
setIsSubmitting(true);

  if (amount < 50) {
    alert("⚠️ Minimum add amount is ৳50");
    return;
  }

  try {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    const token = localStorage.getItem("token");

    if (!storedUser?.username || !token) {
      return showModal(
        "❌ Login Required",
        "আপনি লগইন করেননি। লগইন করে আবার চেষ্টা করুন।",
        "error"
      );
    }

    if (!trxId) {
      return showModal(
        "⚠️ Missing Transaction ID",
        "দয়া করে আপনার সঠিক ট্রানজেকশন আইডি লিখুন!",
        "warning"
      );
    }
// 🚫 Already Approved Transaction (Frontend)
if (isApprovedTrx(trxId)) {
  return showModal(
    "🚫 Transaction Already Used",
    "আপনার এই Transaction ID দিয়ে একবার Funds Approved হয়েছে।\n\n" +
      "দ্বিতীয়বার একই Transaction ব্যবহার করার মানে কি?\n" +
      "⚠️ এই ধরনের কাজ প্রতারণা হিসেবে গণ্য হতে পারে।",
    "error",
    () => {
      window.location.href = "/addfunds";
    }
  );
}
// ❌ Invalid / Fake Transaction ID
if (!isValidTrxId(trxId, method)) {
  return showModal(
    "🚫 Invalid Transaction ID",
    "আপনার দেওয়া Transaction ID টি সঠিক নয়।\n\n" +
      "ভুল বা ভুয়া Transaction ব্যবহার করা প্রতারণা হিসেবে গণ্য হবে।",
    "error",
    () => {
      window.location.href = "/addfunds";
    }
  );
}

// 🔁 Same Transaction Used Before
if (isDuplicateTrx(trxId, amount)) {
  return showModal(
    "⚠️ Duplicate Fund Request",
    "এই Transaction ID দিয়ে ইতোমধ্যে একবার Fund Request করা হয়েছে।\n\n" +
      "Fund Approved হওয়া পর্যন্ত অপেক্ষা করুন।",
    "warning",
    () => {
      window.location.href = "/addfunds";
    }
  );
}
    const res = await axios.post(
      "https://api.speedfollowinfo.com/api/funds",
      {
        amount,
        method,
        transactionId: trxId,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (res.data?.fund) {
// 🏁 Save Approved Transaction (Frontend Lock)
const approved = JSON.parse(localStorage.getItem("approvedTrx")) || [];
approved.push(trxId.toLowerCase());
localStorage.setItem("approvedTrx", JSON.stringify(approved));
    // 🔒 Save Pending Fund (Frontend Lock)
const pending = JSON.parse(localStorage.getItem("pendingFunds")) || [];
pending.push({
  trxId,
  amount,
  method,
  time: Date.now(),
});
localStorage.setItem("pendingFunds", JSON.stringify(pending));
      return showModal(
        `🎉 Fund Request Submitted!`,
        `আপনার ৳${amount} টাকার ফান্ড রিকোয়েস্ট গ্রহণ করা হয়েছে।  
         কিছুক্ষণ অপেক্ষা করুন, ফান্ড Approve করা হবে।  
         ⚠️ *টাকা না দিয়ে Verify করলে Account BAN করা হবে!*`,
        "success",
        () => { window.location.href = "/addfunds"; }
      );
    } else {
      return showModal(
        "⚠️ Failed!",
        "রিকোয়েস্ট সাবমিট হয়নি, আবার চেষ্টা করুন।",
        "error"
      );
    }
  } catch (err) {
    console.error("❌ Error:", err);
    return showModal(
      "❌ Server Error",
      "সার্ভার সমস্যা, পরে চেষ্টা করুন।",
      "error"
    );
  }
};
  // ================================
  // Step parser for (Copy)
  // ================================
  const renderStep = (text) => {
    if (text.includes("(Copy)")) {
      const number = text.match(/\d{11}/)?.[0] || selected.number;
      const parts = text.split("(Copy)");
      return (
        <>
          {parts[0]}
          <button
            onClick={() => handleCopy(number)}
            className="text-[#f2a900] underline hover:text-[#ffd700]"
          >
            (Copy)
          </button>
        </>
      );
    }
    return text;
  };

  // ================================
  // UI
  // ================================
  return (
    <div className="min-h-screen bg-[#0b0f1a] text-white flex flex-col items-center p-6">
      <div className="text-center mb-8">
        <h1 className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-[#ffcc33] to-[#ff0066] drop-shadow-lg">
          ⚡ Speed Follow LTD
        </h1>
        <p className="text-gray-400 mt-2 text-sm">
          Mobile Banking | Bank Transfer
        </p>
      </div>

      <button
        onClick={() => (window.location.href = "/addfunds")}
        className="flex items-center gap-2 mb-6 bg-[#161c34] px-4 py-2 rounded-lg text-gray-300 hover:text-white hover:bg-[#1f2750] transition"
      >
        <ArrowLeft size={18} /> Back to Add Funds
      </button>

      <div
        className="relative w-full max-w-2xl rounded-2xl shadow-2xl border border-[#2f3b6c]/40 overflow-hidden p-8"
        style={{
          background: `linear-gradient(145deg, ${selected.color}40, #161c34 80%)`,
        }}
      >
        <div className="flex items-center gap-4 mb-6">
          <img
            src={selected.logo}
            alt={selected.name}
            className="w-16 h-16 rounded-full border-2 border-white shadow-md bg-white p-1"
          />
          <div>
            <h2 className="text-3xl font-bold" style={{ color: selected.color }}>
              {selected.name} Sent Money
            </h2>
            <p className="text-gray-300 text-sm">
              Send Money via {selected.name} to complete your payment
            </p>
          </div>
        </div>

        <div className="bg-[#0f1530]/70 p-5 rounded-xl border border-[#2f3b6c]/40 mb-6">
          <h3 className="text-lg font-semibold mb-2 text-[#f2a900]">
            📞 Personal Number
          </h3>
          <p className="text-2xl font-bold mb-3 flex items-center gap-3">
            {selected.number}
            <button
              onClick={() => handleCopy(selected.number)}
              className="text-[#f2a900] underline text-sm hover:text-[#ffd700]"
            >
              (Copy)
            </button>
          </p>
          <p className="text-sm text-gray-400">
            Amount to Send:{" "}
            <span className="text-[#00ff99] font-semibold">৳{amount}</span> via{" "}
            <span style={{ color: selected.color, fontWeight: "bold" }}>
              {selected.name}
            </span>
          </p>
        </div>

        <div className="mb-6">
          <label className="block mb-2 text-sm text-gray-400">
            🧾 Enter Transaction ID
          </label>
          <input
  type="text"
  value={trxId}
  onChange={(e) => setTrxId(e.target.value)}
  placeholder="সঠিক ট্রানজেকশন আইডি দিন"
  className="w-full p-3 rounded-lg bg-[#1b2142] border border-[#2f3b6c] text-white focus:ring-2 focus:ring-purple-500 outline-none tracking-widest"
  autoComplete="off"
/>
        </div>

        <button
  onClick={handleConfirm}
  disabled={isSubmitting}
  className={`w-full py-3 rounded-lg font-bold text-lg bg-gradient-to-r from-[#FFD700] to-[#FF9900] hover:opacity-90 transition shadow-lg shadow-yellow-600/40 text-black ${isSubmitting ? "opacity-50 cursor-not-allowed" : ""}`}
>
  ✅ VERIFY
</button>

        <div className="mt-8 bg-[#0f1530]/90 p-4 rounded-lg border border-[#2f3b6c]/40 text-gray-300 text-sm leading-relaxed">
          <h3 className="text-[#f2a900] text-lg font-bold mb-2">
            📘 Step-by-Step Instructions
          </h3>
          <ul className="space-y-2">
            {selected.steps.map((step, i) => (
              <li key={i}>• {renderStep(step)}</li>
            ))}
          </ul>
        </div>
      </div>

      <p className="mt-10 text-gray-500 text-sm">
        © 2025 Speed Follow LTD. All Rights Reserved.
      </p>
    </div>
  );
}